var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar/gaps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99953 9.99442C7.16144 9.99442 6.47573 10.6801 6.47573 11.5182C6.47573 12.3563 7.16144 13.042 7.99953 13.042C8.83763 13.042 9.52334 12.3563 9.52334 11.5182C9.52334 10.6801 8.83763 9.99442 7.99953 9.99442ZM12.571 6.1849H11.8091V4.66109C11.8091 2.55823 10.1024 0.851562 7.99953 0.851562C6.26239 0.851562 4.7462 2.0249 4.31192 3.70871C4.20525 4.12013 4.44906 4.53156 4.86049 4.63823C5.2643 4.7449 5.68334 4.50109 5.79001 4.08966C6.04906 3.08394 6.95573 2.37537 7.99953 2.37537C9.25668 2.37537 10.2852 3.40394 10.2852 4.66109V6.1849H3.42811C2.59001 6.1849 1.9043 6.87061 1.9043 7.70871V15.3278C1.9043 16.1658 2.59001 16.8516 3.42811 16.8516H12.571C13.4091 16.8516 14.0948 16.1658 14.0948 15.3278V7.70871C14.0948 6.87061 13.4091 6.1849 12.571 6.1849ZM12.571 14.5658C12.571 14.9849 12.2281 15.3278 11.8091 15.3278H4.19001C3.77096 15.3278 3.42811 14.9849 3.42811 14.5658V8.47061C3.42811 8.05156 3.77096 7.70871 4.19001 7.70871H11.8091C12.2281 7.70871 12.571 8.05156 12.571 8.47061V14.5658Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaps);
export default __webpack_public_path__ + "static/media/gaps.2b12cf636390b4b60f0f67862b8c3f79.svg";
export { ForwardRef as ReactComponent };